import { CSSProperties } from "react";

export const container: CSSProperties = {
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  marginTop: 10,
  height: "75%",
};

export const illustration: CSSProperties = {
  width: 125,
};

export const reason: CSSProperties = {
  textAlign: "center",
};

export const title: CSSProperties = {
  paddingTop: 10,
  marginBottom: 0,
  textAlign: "center",
};

export const description: CSSProperties = {
  textAlign: "center",
};

export const button: CSSProperties = {
  display: "block",
  marginBottom: 10,
};
